// externals
import React from 'react';

// components
import { PackageAccordionItem } from './PackageAccordionItem';
import {
    PackagesSectionBlock,
    PackagesSectionHeader,
    PackagesSectionTitle,
    ExpandCollapseButton,
    PackageContainer
} from '../PackagesSection.style';

// types
import type { OptionalPackagesProps } from '../../../types/InstalledOptionalEquipmentProps';

export const OptionalPackages: React.FC<OptionalPackagesProps> = ({
    optionalPackages,
    allExpanded,
    isPackageExpanded,
    togglePackage,
    toggleExpandCollapseAll
}) => (
    <PackagesSectionBlock>
        <PackagesSectionHeader>
            <PackagesSectionTitle level={7} weight="semibold" forwardedAs="h3">
                Optional Packages
            </PackagesSectionTitle>
            {optionalPackages.filter((optionalPackage) => optionalPackage.contents.length > 0).length > 1 && (
                <ExpandCollapseButton
                    forwardedAs="button"
                    size="xsmall"
                    weight="semibold"
                    data-testid="expand-collapse-all"
                    onClick={toggleExpandCollapseAll}
                    aria-label={allExpanded ? 'Collapse all packages' : 'Expand all packages'}
                >
                    {allExpanded ? 'Collapse All' : 'Expand All'}
                </ExpandCollapseButton>
            )}
        </PackagesSectionHeader>

        <PackageContainer>
            {optionalPackages.map((optionalPackage, index) => (
                <PackageAccordionItem
                    key={index}
                    optionalPackage={optionalPackage}
                    index={index}
                    isOpen={isPackageExpanded(index)}
                    onToggle={() => togglePackage(index)}
                />
            ))}
        </PackageContainer>
    </PackagesSectionBlock>
);
